export default __webpack_public_path__ + "static/media/Kenya.58c64e37.svg";